// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f0f1e 0%, #1a1a2e 50%, #16213e 100%);
  padding: 2rem;
}

.login-box {
  background: rgba(26, 26, 46, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 3rem;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(88, 101, 242, 0.2);
}

.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-header h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  background: linear-gradient(90deg, #5865F2, #ec4899);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.login-header p {
  color: #b0b3c1;
  font-size: 1.1rem;
}

.login-content h2 {
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
}

.login-content > p {
  color: #b0b3c1;
  margin-bottom: 2rem;
}

.discord-login-btn {
  background-color: #5865F2;
  color: #ffffff;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 100%;
  transition: all 0.3s ease;
}

.discord-login-btn:hover {
  background-color: #4752C4;
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(88, 101, 242, 0.4);
}

.login-info {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(88, 101, 242, 0.2);
}

.login-info p {
  color: #b0b3c1;
  margin: 0.5rem 0;
  font-size: 0.95rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0EAA0E;EAC1E,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #0f0f1e 0%, #1a1a2e 50%, #16213e 100%);\n  padding: 2rem;\n}\n\n.login-box {\n  background: rgba(26, 26, 46, 0.8);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 3rem;\n  max-width: 500px;\n  width: 100%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  border: 1px solid rgba(88, 101, 242, 0.2);\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.login-header h1 {\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n  background: linear-gradient(90deg, #5865F2, #ec4899);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.login-header p {\n  color: #b0b3c1;\n  font-size: 1.1rem;\n}\n\n.login-content h2 {\n  font-size: 1.8rem;\n  margin-bottom: 0.5rem;\n}\n\n.login-content > p {\n  color: #b0b3c1;\n  margin-bottom: 2rem;\n}\n\n.discord-login-btn {\n  background-color: #5865F2;\n  color: #ffffff;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  width: 100%;\n  transition: all 0.3s ease;\n}\n\n.discord-login-btn:hover {\n  background-color: #4752C4;\n  transform: translateY(-3px);\n  box-shadow: 0 10px 30px rgba(88, 101, 242, 0.4);\n}\n\n.login-info {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(88, 101, 242, 0.2);\n}\n\n.login-info p {\n  color: #b0b3c1;\n  margin: 0.5rem 0;\n  font-size: 0.95rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
